module.exports = __webpack_public_path__ + "static/media/poster2.dc30d1df.png";